import { useMutation } from "@apollo/react-hooks";
import {
  Avatar,
  Button,
  Card,
  Checkbox,
  Divider,
  Form,
  Input,
  Layout,
  Radio,
} from "antd";
import React, { useContext, useState } from "react";
import { Link } from "react-router-dom";
import { APP_LOGO_URL } from "../../../assets";
import Footer from "../../../components/common/sharedLayout/Footer";
import { AuthContext } from "../../../context";
import { CheckError } from "../../../utils/ErrorHandling";
import { EDIT_CARDID_AND_ROLE_MUTATION } from "../../../graphql/mutation";
import { useForm } from "../../../utils/hooks";

const { Content } = Layout;

export default (props) => {
  const { user, login, logout } = useContext(AuthContext);
  const { onChange, onSubmit, values } = useForm(editCardIDAndRole, {
    userLevel: 0,
    cardID: "",
  });

  const [editCardIDAndRoleCallback, editCardIDAndRoleStatus] = useMutation(
    EDIT_CARDID_AND_ROLE_MUTATION,
    {
      update(_, { data: { editCardIDAndUserLevel: userData } }) {
        //reset login stuff
        login(userData);
        props.history.push("/dashboard");
      },
      variables: values,
      onError(err) {
        CheckError(err);
      },
    }
  );
  const [isAgreementChecked, setIsAgreementChecked] = useState(false);

  function editCardIDAndRole() {
    editCardIDAndRoleCallback();
  }

  return (
    <Layout className="layout">
      <Content className='gg-centered-content'>
        <Card className='gg-auth-card'>
          <div className='gg-auth-header'>
            <Avatar
              className='gg-auth-header__logo'
              size={40}
              alt="Face In"
              src={APP_LOGO_URL.link}
              onError={(err) => {
                console.log(err);
              }}
            />
            <h2>Just a few seconds...</h2>
            <p>
              Dear {user.firstName} {user.lastName}, tell us more about you!
            </p>
          </div>
          <Form
            name="basic"
            initialValues={{ userLevel: values.role, cardID: values.cardID }}
            onFinish={onSubmit}
          >
            <Form.Item
              label="Staff ID/ID No"
              name="cardID"
              rules={[
                {
                  required: true,
                  message: "Please input your staff ID/ID No!",
                },
              ]}
            >
              <Input
                placeholder="Enter your staff ID/ID No"
                name="cardID"
                onChange={onChange}
              />
            </Form.Item>
            <Form.Item label="Role" name="userLevel" valuePropName="checked">
              <Radio.Group
                name="userLevel"
                value={values.userLevel}
                onChange={onChange}
              >
                <Radio value={0}>Student/Employee</Radio>
                <Radio value={1}>Admin</Radio>
              </Radio.Group>
            </Form.Item>
            <Divider />
            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                loading={editCardIDAndRoleStatus.loading}
              >
                Submit
              </Button>
            </Form.Item>
          </Form>
          <Button
            type="danger"
            htmlType="submit"
            disabled={editCardIDAndRoleStatus.loading}
            onClick={() => logout()}
          >
            Logout
          </Button>
        </Card>
      </Content>
      <Footer />
    </Layout>
  );
};
